'use strict';

var _alkali = require('alkali');

var _alkali2 = _interopRequireDefault(_alkali);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function makeExample(code) {
	var content = new _alkali.Variable(code);
	var Example = (0, _alkali.Div)('.demo', [(0, _alkali.Div)('.demo-contents', [(0, _alkali.H3)('.demo-header', ['EXAMPLE']), (0, _alkali.Textarea)(content, { spellcheck: false }), (0, _alkali.Div)('.output', {
		created: function created(properties) {
			var _this = this;

			properties.code = content.to(function (newCode) {
				var container = _this;
				container.innerHTML = '';
				try {
					container.appendChild(evalWith(newCode, _alkali2.default, container));
				} catch (e) {
					container.textContent = e.message;
				}
			});
		}
	})]), (0, _alkali.Div)('.fade')], {
		onclick: function onclick() {
			this.className += ' active';
		}
	});
	var example = new Example();
	document.body.addEventListener('click', function (event) {
		example.className = example.className.replace(/ active/g, '');
		if (example.contains(event.target)) {
			example.className += ' active';
		}
	});
	return example;
}
var examples = document.querySelectorAll('.example');
for (var i = 0, l = examples.length; i < l; i++) {
	var example = examples[i];
	var code = example.textContent;
	example.parentNode.replaceChild(makeExample(code), example);
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/index.js
 ** module id = 0
 ** module chunks = 0
 **/